export enum DeliveryMechanism {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}
